// extracted by mini-css-extract-plugin
export default {"containAll":"app_containAll__x3QfS"};